import { Form, message, Modal } from "antd";
import { Rule } from "antd/lib/form";
import { issueCategoryApi } from "api/issueCategory.api";
import { AppButton, AppInput, AppTextArea } from "components/antd-ui";
import { observer } from "mobx-react";
import { useEffect, useState } from "react";
import { IssueCategory } from "types/issueCategory";
import { ModalStatus } from "types/modal";

const rules: Rule[] = [{ required: true }];

interface NewsForm {
  name: string;
  description: string;
}

export const IssueCategoryModal = observer(
  ({
    visible,
    status,
    issueCategory,
    onClose,
    onSubmitOk,
  }: {
    visible: boolean;
    status: ModalStatus;
    issueCategory: Partial<IssueCategory>;
    onClose: () => void;
    onSubmitOk: () => void;
  }) => {
    const [form] = Form.useForm<NewsForm>();
    const [loading, setLoading] = useState(false);

    useEffect(() => {
      if (status == "create" && visible) {
        form.resetFields();
      }
    }, [visible, status]);

    useEffect(() => {
      form.setFieldsValue({ name: issueCategory.name, description: issueCategory.description });
      return () => {};
    }, [issueCategory]);

    const createData = async () => {
      const valid = await form.validateFields();
      const data = form.getFieldsValue();
      setLoading(true);
      try {
        await issueCategoryApi.create({
          issueCategory: {
            ...data,
          },
        });
        message.success("Tạo mới thành công!");
        onClose();
        onSubmitOk();
      } finally {
        setLoading(false);
      }
    };

    const updateData = async () => {
      const valid = await form.validateFields();
      const data = {
        issueCategory: {
          ...form.getFieldsValue(),
        },
      };

      setLoading(true);
      try {
        await issueCategoryApi.update(issueCategory?.id || 0, data);
        message.success("Cập nhật thành công");
        onClose();
        onSubmitOk();
      } finally {
        setLoading(false);
      }
    };

    const handleSubmit = async () => {
      if (status === "create") {
        await createData();
        return;
      }

      await updateData();
    };

    return (
      <Modal
        style={{ top: 15 }}
        onCancel={onClose}
        open={visible}
        title={
          <h1 className="text-xl font-bold text-center">
            {status === "create" ? "Tạo mới loại sự cố" : "Cập nhật loại sự cố"}
          </h1>
        }
        footer={null}
        className="app-form-modal"
      >
        <div className="app-form-modal__body">
          <section className="app-form-modal__section">
            <Form layout="vertical" form={form}>
              <Form.Item label="Tên loại sự cố" name="name" rules={rules}>
                <AppInput placeholder="Nhập tên loại sự cố" />
              </Form.Item>

              <Form.Item label="Mô tả" name="description" rules={rules}>
                <AppTextArea placeholder="Nhập mô tả" />
              </Form.Item>
            </Form>
          </section>
        </div>
        <div className="ant-modal-footer">
          <div className="flex gap-2 justify-end">
            <AppButton onClick={onClose}>Hủy</AppButton>
            <AppButton tone="primary" loading={loading} onClick={handleSubmit}>
              {status === "create" ? "Xác nhận" : "Cập nhật"}
            </AppButton>
          </div>
        </div>
      </Modal>
    );
  },
);
